var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1525 10.8995L12.1369 19.9151C10.0866 21.9654 6.7625 21.9654 4.71225 19.9151C2.662 17.8649 2.662 14.5408 4.71225 12.4905L13.7279 3.47489C15.0947 2.10806 17.3108 2.10806 18.6776 3.47489C20.0444 4.84173 20.0444 7.05781 18.6776 8.42464L10.0156 17.0867C9.33213 17.7701 8.22409 17.7701 7.54068 17.0867C6.85726 16.4033 6.85726 15.2952 7.54068 14.6118L15.1421 7.01043",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.7a90fb901bd814bdb1513aa5f9464c77.svg";
export { ForwardRef as ReactComponent };